import { archiveFontWithId, beginLoadingFonts, storeFonts } from 'js/src/data/fonts/fonts-actions';
import { areFontsLoaded, isFontListLoading } from 'js/src/data/fonts/fonts-selectors';
import type { ReadonlyFontAsset } from 'js/src/data/fonts/fonts-types';
import FontLoader from 'js/src/libs/font-loader';
import type { AppDispatch, GetRootState } from 'js/src/libs/RootState';

export function loadFonts() {
    return (dispatch: AppDispatch, getState: GetRootState) => {
        if (isFontListLoading(getState())) {
            return;
        }

        dispatch(beginLoadingFonts());
        new FontLoader((fontList) => {
            dispatch(storeFonts({ fontList }));
        });
    };
}

/**
 * Ensures fonts are loaded before proceeding. Returns a Promise that resolves
 * once fonts are available in Redux. If fonts are already loaded, resolves immediately.
 */
export function ensureFontsLoaded() {
    return (dispatch: AppDispatch, getState: GetRootState): Promise<void> => {
        if (areFontsLoaded(getState())) {
            return Promise.resolve();
        }

        return new Promise<void>((resolve) => {
            dispatch(beginLoadingFonts());
            new FontLoader((fontList) => {
                dispatch(storeFonts({ fontList }));
                resolve();
            });
        });
    };
}

export function archiveFont(fontAsset: ReadonlyFontAsset) {
    return (dispatch: AppDispatch) => {
        FontLoader.deleteFont(fontAsset);
        dispatch(archiveFontWithId({ fontId: fontAsset.id }));
    };
}

export function addFont(fontAsset: ReadonlyFontAsset) {
    return (dispatch: AppDispatch) => {
        FontLoader.addFont(fontAsset);
        dispatch(storeFonts({ fontList: [fontAsset] }));
    };
}
